import {APIResponse} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {UserDTO} from "./model/user/UserDTO";
import {IUserInfo} from "./model/user/IUserInfo";

class UserDataApiDefinition extends ApiDefinition{
    constructor() {
        super("/users");
    }

    async getDataInfo(usernameOrId: string | number): Promise<APIResponse<IUserInfo>> {
        if(typeof usernameOrId === "number") {
            return this.get(`${usernameOrId}`)
        }
        return this.get(`info/${usernameOrId}`)
    }

    async getCurrentUser(): Promise<APIResponse<UserDTO>> {
        return this.get(`info`)
    }
}

export const UserDataApi = new UserDataApiDefinition();